/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FetchTransactionsInput = {|
  clientMutationId?: ?string,
  endDate: any,
  integrationItemId: string,
  startDate: any,
|};
export type fetchPlaidTransactionsMutationVariables = {|
  input: FetchTransactionsInput
|};
export type fetchPlaidTransactionsMutationResponse = {|
  +fetchPlaidTransactions: ?{|
    +errorMessage: ?string,
    +successMessage: ?string,
  |}
|};
export type fetchPlaidTransactionsMutation = {|
  variables: fetchPlaidTransactionsMutationVariables,
  response: fetchPlaidTransactionsMutationResponse,
|};
*/


/*
mutation fetchPlaidTransactionsMutation(
  $input: FetchTransactionsInput!
) {
  fetchPlaidTransactions(input: $input) {
    errorMessage
    successMessage
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "FetchTransactionsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FetchTransactionsPayload",
    "kind": "LinkedField",
    "name": "fetchPlaidTransactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchPlaidTransactionsMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchPlaidTransactionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "fetchPlaidTransactionsMutation",
    "operationKind": "mutation",
    "text": "mutation fetchPlaidTransactionsMutation(\n  $input: FetchTransactionsInput!\n) {\n  fetchPlaidTransactions(input: $input) {\n    errorMessage\n    successMessage\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be64f324f929b76fb42bfe2f8aa65aba';

module.exports = node;
